
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BootstrapContext } from 'rev-shared/bootstrap/BootstrapContext';
import { UserContextService } from 'rev-shared/security/UserContext.Service';

@Injectable({
	providedIn: 'root'
})
export class TokenHttpInterceptor implements HttpInterceptor {

	constructor(
		private injector: Injector
	) {}

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const UserContext = this.injector.get<UserContextService>(UserContextService);
		const token = UserContext.getUser().token;
		const addAuthHeader = token?.accessToken &&
			!request.url.includes(BootstrapContext.analyticsUrl) &&
			!request.headers?.has('Authorization') &&
			request.url.startsWith('/');

		return next.handle(!addAuthHeader ? request : request.clone({
			setHeaders: {
				Authorization: 'vbrick ' + token.accessToken + (token.csrfToken ? ' ' + token.csrfToken : '')
			}
		}));
	}
}
